import { FiltroPersonamast } from './../../../personamast/dominio/FiltroPersonamast';
import { CoPedidosServicio } from './../../../../comercial/pedido/servicio/copedidos.service';
import { CoDocumentoServicio } from './../../../../comercial/codocumento/service/codocumento.service';
import { CoDocumento } from './../../../../comercial/codocumento/dominio/CoDocumento';
import { SelectItem, MessageService } from 'primeng/api';
import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DtoPersonamast } from 'src/app/erp/core/personamast/dominio/DtoPersonamast';
import { PrincipalBaseComponent } from 'src/app/util/PrincipalBaseComponent';
import { NoAuthorizationInterceptor } from 'src/app/util/interceptor/NoAuthorizationInterceptor';
import { PersonamastSelectorComponent } from '../../../personamast/vista/selector/personamastselector.component';
import { ClientemastServicio } from '../../servicio/clientemast.service';
import { DtoLineaCredito } from '../../dominio/DtoLineaCredito';
import { MaMiscelaneosdetalleServicio } from '../../../mamiscelaneosdetalle/service/mamiscelaneosdetalle.service';
import { TipocambiomastPk } from '../../../tipocambiomast/dominio/Tipocambiomast';
import { TipocambiomastServicio } from '../../../tipocambiomast/service/tipocambiomast.service';
import { parse } from 'url';

@Component({
    templateUrl: './linea-credito.component.html'
})
export class LineaCreditoComponent extends PrincipalBaseComponent implements OnInit {

    PG_DOCUMENTOS_LISTAR: number = 0;
    PG_CLIENTE_SELECTOR: number = 3;

    aprobar: Boolean = false;

    lstEstados: SelectItem[] = [];
    lstEstadosCoti: SelectItem[]=[];

    PG_ACTUAL: number = 0;

    @ViewChild(PersonamastSelectorComponent,{static:false}) personamastSelectorComponent: PersonamastSelectorComponent;

    cliente: number = -1;
    nombreCliente: string = "";
    verCancelar: Boolean=false;
    lineacliente:Boolean=false;
    utilizado: number=0;
    sobregiro: Boolean= false;
    sobregiroLocal: number=0;
    sobregiroEx: number=0;
    filtroCancelar: FiltroPersonamast = new FiltroPersonamast();

    beanDocumento: CoDocumento = new CoDocumento();
    bean: DtoLineaCredito = new DtoLineaCredito();

    get clasificacion(): string {
        switch (this.bean.clasificacion) {
            case "A":
                return "Excelente";
            case "B":
                return "Bueno";
            case "C":
                return "Regular";
            case "D":
                return "Malo";
            default:
                return "";
        }
    }

    constructor(
        private cdref: ChangeDetectorRef,
        private tipocambiomastServicio: TipocambiomastServicio,
        private coPedidosServicio: CoPedidosServicio, 
        private maMiscelaneosdetalleServicio: MaMiscelaneosdetalleServicio,
        private router: Router,
        private route: ActivatedRoute,
        private clientemastServicio: ClientemastServicio,
        noAuthorizationInterceptor: NoAuthorizationInterceptor,
        messageService: MessageService,
    ) { super(noAuthorizationInterceptor, messageService); }

    tipoCambio: number;

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }


    ngOnInit(): void {
        super.ngOnInit();
        this.cargarEstados();

        var pk = new TipocambiomastPk();
        pk.fechacambio = new Date();

        this.tipocambiomastServicio.obtenerTipoCambio(pk).then(
            tipoCambio => {
                if (tipoCambio != null) {
                    if (tipoCambio.factorcobranzaventa != null) {
                        this.tipoCambio = tipoCambio.factorcobranzaventa;

                        this.lstEstados.push({ label: ' -- Todos -- ', value: null });
                        this.maMiscelaneosdetalleServicio.listarPorCabecera("CO", "999999", "DOCUEST").then(
                            res => {
                                res.forEach(
                                    reg => {
                                        this.lstEstados.push({ label: reg.descripcionlocal, value: reg.pk.codigoelemento.trim() });
                                    }
                                );

                                const cliente = this.route.snapshot.params['cliente'];
                                const filtro = this.route.snapshot.params['filtro'];
                                if(cliente!=null){
                                    this.lineacliente=true;
                                    this.verCancelar=true;                                    
                                    this.filtroCancelar=filtro;                                    
                                    this.filtroCancelar = JSON.parse(filtro) as FiltroPersonamast;
                                }
                                if (cliente) {
                                    this.lineacliente=true;
                                    this.filtroCancelar=filtro;                                    
                                    this.cargarDatosCliente(JSON.parse(cliente) as DtoPersonamast);
                                    this.filtroCancelar = JSON.parse(filtro) as FiltroPersonamast;
                                }       
                           
                            }
                        );
                    }
                    else {
                        this.mostrarMensajeInfo("No hay un tipo de cambio para cobranzas para hoy");
                    }
                }
                else {
                    this.mostrarMensajeInfo("No hay un tipo de cambio para hoy");
                }
            }
        );

       // if(this.lineacliente==false){
        //    this.cargarAprobar();            
       // }
        
    }

    cargarCliente(bean: DtoPersonamast) {
        this.cliente = bean.persona;
        this.nombreCliente = bean.busqueda;
        this.PG_ACTUAL = this.PG_DOCUMENTOS_LISTAR;
        this.cargarDatosCliente(bean);
    }

    cargarDatosCliente(bean: DtoPersonamast) {
        this.bloquearPagina();        
        this.clientemastServicio.obtenerLineaCredito(bean.persona).then(
            res => {     
                if(res.lineaCreditoMoneda==null){
                    res.lineaCreditoMoneda="EX";                    
                }                            
                if (res.lineaCredito == null || res.lineaCredito == undefined) {
                    res.lineaCredito = 0;
                }
                var par_monto = 0;
                ////Linea de Credito
                if (res.lineaCreditoMoneda == "EX") {
                    res.lineaCreditoExMonto09 = parseFloat((res.lineaCredito).toFixed(2));
                    res.lineaCreditoLoMonto10 = parseFloat((res.lineaCredito * this.tipoCambio).toFixed(2));
                }
                else {
                    res.lineaCreditoExMonto09 = parseFloat((res.lineaCredito / this.tipoCambio).toFixed(2));
                    res.lineaCreditoLoMonto10 = parseFloat((res.lineaCredito).toFixed(2));
                }


                if(this.lineacliente==true){
                    if (res.lineaCreditoMoneda == "EX") {
                        res.montoAprobarExMonto02 = parseFloat((par_monto).toFixed(2));
                        res.montoAprobarLoMonto04 = parseFloat((par_monto * this.tipoCambio).toFixed(2));
                    }
                    else {
                        res.montoAprobarExMonto02 = parseFloat((par_monto / this.tipoCambio).toFixed(2));
                        res.montoAprobarLoMonto04 = parseFloat((par_monto).toFixed(2));
                    }
                }
                if(this.lineacliente==false){
                    if (res.lineaCreditoMoneda == "EX") {
                        res.montoAprobarExMonto02 = parseFloat((this.beanDocumento.montototal).toFixed(2));
                        res.montoAprobarLoMonto04 = parseFloat((this.beanDocumento.montototal * this.tipoCambio).toFixed(2));
                        this.utilizado=res.montoAprobarExMonto02+this.beanDocumento.montototal;
                    }
                    else {
                        res.montoAprobarExMonto02 = parseFloat((this.beanDocumento.montototal / this.tipoCambio).toFixed(2));
                        res.montoAprobarLoMonto04 = parseFloat((this.beanDocumento.montototal).toFixed(2));
                        this.utilizado=res.montoAprobarLoMonto04+this.beanDocumento.montototal;
                    }
                }
                //Monto to Approve
                

                //montoAprobarLoMonto04

                var TotalPendienteDolar = 0;
                var TotalPendienteLocal = 0;
            

                res.documentos.forEach(
                    doc => {

                        if (doc.clasificacion != "AD") {
                            if (doc.monedaDocumento == "EX") {
                                TotalPendienteDolar = TotalPendienteDolar + doc.montoTotal - doc.montoPagado;
                                TotalPendienteLocal = TotalPendienteLocal + 0;                                
                            }
                            else {
                                TotalPendienteLocal = TotalPendienteLocal + doc.montoTotal - doc.montoPagado;
                                TotalPendienteDolar = TotalPendienteDolar + 0;
                            }
                        }
                        else {
                            if (doc.monedaDocumento == "EX") {
                                TotalPendienteDolar = TotalPendienteDolar + doc.montoAdelandoSaldo;
                                TotalPendienteLocal = TotalPendienteLocal + 0;
                            }
                            else {
                                TotalPendienteLocal = TotalPendienteLocal + doc.montoAdelandoSaldo;
                                TotalPendienteDolar = TotalPendienteDolar + 0;
                            }
                        }
                    }
                );

               

                res.montoUtilizadoExMonto01 = parseFloat((TotalPendienteDolar + (TotalPendienteLocal / this.tipoCambio)).toFixed(2));
                res.montoUtilizadoLoMonto03 = parseFloat((TotalPendienteLocal + (TotalPendienteDolar * this.tipoCambio)).toFixed(2));


                if (isNaN(res.lineaCreditoExMonto09)) {
                    res.lineaCreditoExMonto09 = 0;
                }
                if (isNaN(res.montoUtilizadoExMonto01)) {
                    res.montoUtilizadoExMonto01 = 0;
                }
                if (isNaN(res.montoAprobarExMonto02)) {
                    res.montoAprobarExMonto02 = 0;
                }
                res.disponibleEx = parseFloat((res.lineaCreditoExMonto09 - res.montoUtilizadoExMonto01 - res.montoAprobarExMonto02).toFixed(2));                

                if (isNaN(res.lineaCreditoLoMonto10)) {
                    res.lineaCreditoLoMonto10 = 0;
                }
                if (isNaN(res.montoUtilizadoLoMonto03)) {
                    res.montoUtilizadoLoMonto03 = 0;
                }
                if (isNaN(res.montoAprobarLoMonto04)) {
                    res.montoAprobarLoMonto04 = 0;
                }
                res.disponibleLo = parseFloat((res.lineaCreditoLoMonto10 - res.montoUtilizadoLoMonto03 - res.montoAprobarLoMonto04).toFixed(2));

                if(res.disponibleEx < 0 ){
                    this.sobregiro=true;
                    this.sobregiroLocal=res.disponibleLo*-1;
                    this.sobregiroEx=res.disponibleEx*-1;
                }

                this.bean = res;                
                this.desbloquearPagina();                
            }
        );
    }

    mostrarSelectorCliente() {
        this.personamastSelectorComponent.iniciarComponente();
    }

    cancelarAccionSelector() {
        this.PG_ACTUAL = this.PG_DOCUMENTOS_LISTAR;
    }

    cancelar() {             
        this.router.navigate(['/royal/cliente-listado', "_",JSON.stringify(this.filtroCancelar)], { skipLocationChange: true });
    }

    cargarAprobar(){        
        const accion = this.route.snapshot.params['accion'] as string;              
        if (accion == 'APROBAR') {
            this.aprobar=true;               
            this.beanDocumento = JSON.parse(this.route.snapshot.params['bean']) as CoDocumento;
            this.obtenerCliente(this.beanDocumento);  
        }
        else {
            throw new Error('NO CONTROLADO AUN');
        }
    }

    obtenerCliente(bean: CoDocumento){

         this.cliente = bean.clientenumero;
         this.nombreCliente = bean.clientenombre;
         this.PG_ACTUAL = this.PG_DOCUMENTOS_LISTAR;         

        const obj: DtoPersonamast = new DtoPersonamast();
        obj.persona = bean.clientenumero;
        obj.nombreCompleto = bean.clientenombre;        
                
         this.cargarDatosCliente(obj);

    }

    aprobarPedido(){
        const obj = this.beanDocumento;        
        obj.montototal=this.utilizado;
        this.bloquearPagina();
        this.coPedidosServicio.aprobarActualizarPedido(obj).then(
            res => {
                this.messageService.add({ severity: 'info', summary: 'Información', detail: this.getMensajeAprobado(obj.pk.numerodocumento)});
                this.router.navigate(["royal/pedido-listado"]); 
                this.desbloquearPagina();
            }
        );

    }
    cancelarPedido(){
        this.router.navigate(["royal/pedido-listado"]); 
    }

    cargarEstados(){
        this.maMiscelaneosdetalleServicio.listarPorCabecera("CO", "999999", "COTIEST").then(
            res => {
                res.forEach(
                    reg => {
                        this.lstEstadosCoti.push({ label: reg.descripcionlocal, value: reg.pk.codigoelemento.trim() });
                    }
                ); 
            }
        );
    }

}
